import React from "react";
import { DisplayFlag } from "components/job/flag/display";

import { getJobExtensionDays } from "@/lib/utils";

const JobNameCell = ({ getValue, row, showFlag = true }) => {
  const name = getValue();
  // const flag = row?.original?.flag;
  const extensionDays = getJobExtensionDays(row.original);

  return (
    <div title={name} className="flex flex-col items-start">
      <span className="truncate font-medium">{name}</span>
      {/* {extensionDays ? (
        <div className="text-red-600">
          Extended by {extensionDays} days
        </div>
      ) : null} */}
      {/* {showFlag && <DisplayFlag flag={flag} />} */}
    </div>
  );
};

export default JobNameCell;
